import axios from 'axios'

export default {
    LOAD_NEW_PLAYER_USER_PLAYLISTS ({commit}, playlistId) {
        return axios.get(`playlists/loadGeneralPlaylistForNewPlayer/${playlistId}/1`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setUserNewPlaylistObject', {playlist: data.payload})
            } else {
                commit('setUserNewPlaylistObject', {playlist: null})
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_USER_PLAYLISTS'} })
        })
    },
    LOAD_NEW_PLAYER_TRENDING_PLAYLISTS ({commit}, playlistId) {
        return axios.get(`playlists/loadGeneralPlaylistForNewPlayer/${playlistId}/2`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setTrendingNewPlaylistObject', {playlist: data.payload})
            } else {
                commit('setTrendingNewPlaylistObject', {playlist: null})
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_TRENDING_PLAYLISTS'} })
        })
    },
    LOAD_NEW_PLAYER_CORP_PLAYLISTS ({commit}, playlistId) {
        return axios.get(`playlists/loadGeneralPlaylistForNewPlayer/${playlistId}/3`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorpNewPlaylistObject', {playlist: data.payload})
            } else {
                commit('setCorpNewPlaylistObject', {playlist: null})
                // commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request : LOAD_NEW_PLAYER_CORP_PLAYLISTS'} })
        })
    },
    GETCURRENTVIDEO ({ commit }, mediaId) {
        return axios.get(`/playlists/getJWVideoByCode/${mediaId}`).then((response) => {
            const { data: { data } } = response
            console.log('data found', data)
            if (data && data.length) {
                commit('setCurrentVideoObject', {videoObject: data})
            } else {
                commit('setCurrentVideoObject', {videoObject: null})
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GET_CURRENT_VIDEO_DATA_SYNC ({commit}, mediaId) {
        return new Promise((resolve, reject) => {
            axios.get(`/playlists/getJWVideoByCode/${mediaId}`)
                .then((response) => {
                    const { data: { data } } = response
                    console.log('video sync', data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log('action fetch error : ', error)
                    reject(null)
                })
        })
    },
    GETVIDEOSUBCATEGORIES ({ commit }, category) {
        return axios.get(`/interests/getSubCategoriesByTitle/${category[0]}/${category[1]}`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setVideoSubcategory', {subCategories: data})
            } else {
                commit('setVideoSubcategory', {subCategories: null})
            }
        }, (err) => {
            commit('setVideoSubcategory', {subCategories: null})
            console.log('err ', err)
        })
    },
    GETFILTEREDWORKVIDEOS ({ commit }, { payload }) {
        commit('setAuthWorkVideo', {videoObject: null})
        return axios.post(`/playlists/getJWPlaylistByMultipleTitle/WORK/${payload.corpId}`, {lstInterestSubCategoryName: payload.lstInterestSubCategoryName}).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setAuthWorkVideo', {videoObject: data})
            } else {
                commit('setAuthWorkVideo', {videoObject: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAuthWorkVideo', {videoObject: null})
        })
    },
    GETFILTEREDLIFEVIDEOS ({ commit }, { payload }) {
        commit('setAuthLifeVideo', {videoObject: null})
        return axios.post(`/playlists/getJWPlaylistByMultipleTitle/LIFE/${payload.corpId}`, {lstInterestSubCategoryName: payload.lstInterestSubCategoryName}).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setAuthLifeVideo', {videoObject: data})
            } else {
                commit('setAuthLifeVideo', {videoObject: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAuthLifeVideo', {videoObject: null})
        })
    },
    GETFILTEREDMONEYVIDEOS ({ commit }, { payload }) {
        commit('setAuthMoneyVideo', {videoObject: null})
        return axios.post(`/playlists/getJWPlaylistByMultipleTitle/MONEY/${payload.corpId}`, {lstInterestSubCategoryName: payload.lstInterestSubCategoryName}).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setAuthMoneyVideo', {videoObject: data})
            } else {
                commit('setAuthMoneyVideo', {videoObject: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAuthMoneyVideo', {videoObject: null})
        })
    },
    GETFILTEREDMINDBODYVIDEOS ({ commit }, { payload }) {
        commit('setAuthMindbodyVideo', {videoObject: null})
        return axios.post(`/playlists/getJWPlaylistByMultipleTitle/MINDBODY/${payload.corpId}`, {lstInterestSubCategoryName: payload.lstInterestSubCategoryName}).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setAuthMindbodyVideo', {videoObject: data})
            } else {
                commit('setAuthMindbodyVideo', {videoObject: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAuthMindbodyVideo', {videoObject: null})
        })
    },
    GET_B2B_VIDEOS_METADATA ({ commit }, videoList) {
        // commit('setAuthMindbodyVideo', {videoObject: null})
        return axios.post('/playlists/getVideosData', {csvVideoCodes: videoList}).then((response) => {
            const { data: { data } } = response
            if (data) {
                console.log('returned videos', data.payload)
                commit('setB2BVideos', {bVideos: data.payload})
            } else {
                commit('setB2BVideos', {bVideos: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setB2BVideos', {bVideos: null})
        })
    },
    GET_B2B_VIDEOS_METADATA_TOPVIDEO ({ commit }, videoList) {
        // commit('setAuthMindbodyVideo', {videoObject: null})
        return axios.post('/playlists/getVideosData', {csvVideoCodes: videoList}).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setB2BTopVideo', {bVideos: data.payload})
            } else {
                commit('setB2BTopVideo', {bVideos: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setB2BTopVideo', {bVideos: null})
        })
    },
    GETPROMOVIDEOFORCODE ({ commit }, mediaId) {
        return axios.get(`/playlists/getJWVideoByCode/${mediaId}`).then((response) => {
            const { data: { data } } = response
            commit('setCurrentPromoVideoObject', {videoObject: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETVIDEOTRANSCRIPT ({ commit }, mediaId) {
        return axios.get(`/playlists/getTranscriptByVideoCode/${mediaId}`).then((response) => {
            const { data: { data } } = response
            commit('setCurrentVideoTranscript', {transcript: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    SETVIDEOSTATUS ({ commit }, statusObject) {
        return axios.post(`/playlists/addUpdateUserVideos/`, statusObject).then((response) => {
            commit('setCurrentVideoStatus', {videoStatus: statusObject})
        }, (err) => {
            console.log('err ', err)
            commit('setCurrentVideoStatus', {videoStatus: statusObject})
        })
    },
    SET_PLAYLIST_VIDEOSTATUS ({ commit }, statusObject) {
        return axios.post(`/playlists/addUpdateWatchedPlaylistVideo`, statusObject).then((response) => {
            console.log('playlist load entry logged')
            // commit('setCurrentVideoStatus', {videoStatus: statusObject})
        }, (err) => {
            console.log('err ', err)
            // commit('setCurrentVideoStatus', {videoStatus: statusObject})
        })
    },
    COPYPLAYLIST ({ commit }, {copyPlaylistObject}) {
        return axios.post(`playlists/copySharedUserPlaylist/`, copyPlaylistObject).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCopiedPlaylistObject', {newPlaylist: data.payload})
            } else {
                commit('setCopiedPlaylistObject', {newPlaylist: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setCopiedPlaylistObject', {newPlaylist: null})
        })
    },
    LOGVIDEOERROR ({ commit }, errorPayload) {
        return axios.post('/logging/writeActivityToQueue', errorPayload).then((response) => {
            console.log('error successfully logged: ', errorPayload)
        }, (err) => {
            console.log('err ', err)
        })
    },
    SETORIGINALVIDEOCODE ({ commit }, videoCode) {
        if (videoCode) {
            commit('setOriginalVideoCode', videoCode)
        } else {
            commit('setOriginalVideoCode', null)
        }
    },
    SETORIGINALVIDEOTITLE ({ commit }, videoTitle) {
        if (videoTitle) {
            commit('setOriginalVideoTitle', videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase())
        } else {
            commit('setOriginalVideoTitle', null)
        }
    },
    GETCORPPAYLOAD ({ commit }, userId) {
        return axios.get(`/corporations/getUserCorporation/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporatePayload', {corp: data.payload})
            } else {
                commit('setCorporatePayload', {corp: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setCorporatePayload', {corp: null})
        })
    },
    GETCORPPAYLOAD_PRIVATE_EVENT_SHARING ({ commit }, userId) {
        return axios.get(`/corporations/getUserCorporationMemberList/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporatePayload', {corp: data.payload})
            } else {
                commit('setCorporatePayload', {corp: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setCorporatePayload', {corp: null})
        })
    },
    GET_TAGGED_EMAIL_LIST ({ commit }, userId) {
        return axios.get(`playlists/getUserSharedEmailRecipient/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setTaggedEmailList', {eList: data.payload})
            } else {
                commit('setTaggedEmailList', {eList: null})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setTaggedEmailList', {eList: null})
        })
    },
    // GET_PODCAST_FOR_SERVICE ({ commit }, podcastServiceName) {
    //     // return axios.get(`/common/getPodcastForService/${podcastServiceName}`).then((response) => {
    //     return axios.get(`/common/getPodcastForService/${podcastServiceName}}`).then((response) => {
    //         const { data: { data } } = response
    //         if (data) {
    //             commit('setServicePodcast', {anyThing: data})
    //             console.log('GET_PODCAST_FOR_SERVICE - DATA FOUND  >>>>>>>>>>>>>>>>>>> data ', data)
    //         } else {
    //             commit('setServicePodcast', {anyThing: null})
    //             console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data ', data)
    //             console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> podcastServiceName ', podcastServiceName)
    //         }
    //     }, (err) => {
    //         console.log('err ', err)
    //         commit('setServicePodcast', {anyThing: null})
    //     })
    // }
    GET_PODCAST_FOR_SERVICE ({ commit }, podcastServiceName) {
        // return axios.get(`/common/getPodcastForService/${podcastServiceName}`).then((response) => {
        return axios.get(`/common/getPodcastForService/${podcastServiceName}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setServicePodcast', {anyThing: data.payload})
                console.log('GET_PODCAST_FOR_SERVICE - DATA FOUND  >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
            } else {
                commit('setServicePodcast', {anyThing: null})
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> data.payload ', data.payload)
                console.log('GET_PODCAST_FOR_SERVICE -- NO DATA FOUND >>>>>>>>>>>>>>>>>>> podcastServiceName ', podcastServiceName)
            }
        }, (err) => {
            console.log('err ', err)
            commit('setServicePodcast', {anyThing: null})
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/videoplayer/actions.js